// Kept out of batch names, which follow an underscore-delimited convention. Not a security control.
// Held as a source string: a shared `g`-flagged regex carries `lastIndex` between `.test()` calls.
const DISALLOWED_BATCH_NAME_CHARS = '[.,]|\\p{Cc}'

/** Used by create, which builds a name from scratch. */
export const sanitizeBatchName = (value: string): string =>
  value.replace(new RegExp(DISALLOWED_BATCH_NAME_CHARS, 'gu'), '')

/** Used by rename, which flags instead: stripping would rewrite the part never touched. */
export const hasDisallowedBatchNameChars = (value: string): boolean =>
  new RegExp(DISALLOWED_BATCH_NAME_CHARS, 'u').test(value)

/** Mirrors the API's `name` limit, which 400s on anything longer. */
export const BATCH_NAME_MAX_LENGTH = 120
